function PlanH({ ...props }) {
	return (
		<g {...props} id="unit-h">
			<g id="furniture">
				<polyline
					points="424.16 845.01 424.16 530.9 484.18 530.9 484.18 845.01 424.16 845.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="493.22 850.49 493.22 847.7 498.75 847.7 498.75 850.49 493.22 850.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="275.89"
					y1="399.29"
					x2="128.59"
					y2="399.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.89"
					y1="417.49"
					x2="275.89"
					y2="411.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.89"
					y1="407.89"
					x2="275.89"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.89"
					y1="401.78"
					x2="271.26"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.66"
					y1="401.78"
					x2="261.66"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.06"
					y1="401.78"
					x2="252.05"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.45"
					y1="401.78"
					x2="242.45"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.85"
					y1="401.78"
					x2="232.85"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.25"
					y1="401.78"
					x2="223.25"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.64"
					y1="401.78"
					x2="213.64"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.04"
					y1="401.78"
					x2="204.04"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.44"
					y1="401.78"
					x2="194.44"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.84"
					y1="401.78"
					x2="184.83"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.23"
					y1="401.78"
					x2="175.23"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.63"
					y1="401.78"
					x2="165.63"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.03"
					y1="401.78"
					x2="156.03"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="152.43"
					y1="401.78"
					x2="146.42"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.82"
					y1="401.78"
					x2="136.82"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.22"
					y1="401.78"
					x2="128.59"
					y2="401.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.59"
					y1="401.78"
					x2="128.59"
					y2="407.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.59"
					y1="411.49"
					x2="128.59"
					y2="417.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.23"
					y1="467.08"
					x2="764.35"
					y2="467.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.23"
					y1="458.48"
					x2="640.23"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.23"
					y1="464.58"
					x2="642.88"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.47"
					y1="464.58"
					x2="652.48"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.08"
					y1="464.58"
					x2="662.08"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.68"
					y1="464.58"
					x2="671.68"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.29"
					y1="464.58"
					x2="681.29"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.89"
					y1="464.58"
					x2="690.89"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.49"
					y1="464.58"
					x2="700.49"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.09"
					y1="464.58"
					x2="710.09"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.7"
					y1="464.58"
					x2="719.7"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.3"
					y1="464.58"
					x2="729.3"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.9"
					y1="464.58"
					x2="738.9"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.5"
					y1="464.58"
					x2="748.51"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.11"
					y1="464.58"
					x2="758.11"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.71"
					y1="464.58"
					x2="764.35"
					y2="464.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.35"
					y1="464.58"
					x2="764.35"
					y2="458.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="203.44 555.41 141.66 555.41 141.66 493.63 203.44 493.63 203.44 555.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="281.48 55.01 281.48 57.51 180.01 57.51 180.01 55.01 281.48 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="281.48"
					y1="55.01"
					x2="281.48"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.48"
					y1="57.51"
					x2="180.01"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.01"
					y1="57.51"
					x2="180.01"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.01"
					y1="55.01"
					x2="281.48"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="332.6 54.02 290.38 54.02 290.38 59.44 332.6 59.44 332.6 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="288.41 53.53 334.57 53.53 334.57 54.02 288.41 54.02 288.41 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="288.41"
					y1="53.53"
					x2="334.57"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.57"
					y1="53.53"
					x2="334.57"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.57"
					y1="54.02"
					x2="288.41"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.41"
					y1="54.02"
					x2="288.41"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="59.44"
					x2="290.38"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.38"
					y1="54.02"
					x2="332.6"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="337.03 59.44 332.6 59.44 332.6 54.02 337.03 54.02 337.03 59.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="337.03"
					y1="59.44"
					x2="332.6"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="59.44"
					x2="332.6"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="54.02"
					x2="337.03"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.03"
					y1="54.02"
					x2="337.03"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="285.95 54.02 290.38 54.02 290.38 59.44 285.95 59.44 285.95 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="285.95"
					y1="54.02"
					x2="290.38"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.38"
					y1="54.02"
					x2="290.38"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.38"
					y1="59.44"
					x2="285.95"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.95"
					y1="59.44"
					x2="285.95"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="55.01"
					x2="290.38"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="339 58.94 337.03 58.94 337.03 54.02 334.57 54.02 334.57 53.53 339 53.53 339 58.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339"
					y1="58.94"
					x2="337.03"
					y2="58.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.03"
					y1="58.94"
					x2="337.03"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.03"
					y1="54.02"
					x2="334.57"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.57"
					y1="54.02"
					x2="334.57"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.57"
					y1="53.53"
					x2="339"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339"
					y1="53.53"
					x2="339"
					y2="58.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="283.98 53.53 288.41 53.53 288.41 54.02 285.95 54.02 285.95 58.94 283.98 58.94 283.98 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="283.98"
					y1="53.53"
					x2="288.41"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.41"
					y1="53.53"
					x2="288.41"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.41"
					y1="54.02"
					x2="285.95"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.95"
					y1="54.02"
					x2="285.95"
					y2="58.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.95"
					y1="58.94"
					x2="283.98"
					y2="58.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.98"
					y1="58.94"
					x2="283.98"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="278.98 55.01 283.98 55.01 283.98 70.01 278.98 70.01 278.98 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="283.98"
					y1="55.01"
					x2="278.98"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.98"
					y1="70.01"
					x2="283.98"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.98"
					y1="70.01"
					x2="283.98"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.98"
					y1="55.01"
					x2="278.98"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="344 55.01 344 70.01 339 70.01 339 55.01 344 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="344"
					y1="70.01"
					x2="344"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339"
					y1="70.01"
					x2="344"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339"
					y1="55.01"
					x2="339"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344"
					y1="55.01"
					x2="339"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="177.51 55.01 182.51 55.01 182.51 70.01 177.51 70.01 177.51 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="182.51"
					y1="55.01"
					x2="177.51"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.51"
					y1="70.01"
					x2="182.51"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.51"
					y1="70.01"
					x2="182.51"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.51"
					y1="55.01"
					x2="177.51"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="611.71 55.01 611.71 57.51 479.48 57.51 479.48 55.01 611.71 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="611.71"
					y1="55.01"
					x2="611.71"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.71"
					y1="57.51"
					x2="479.48"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.48"
					y1="57.51"
					x2="479.48"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.48"
					y1="55.01"
					x2="611.71"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="662.21 54.02 620.61 54.02 620.61 59.44 662.21 59.44 662.21 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="618.64 53.53 664.19 53.53 664.19 54.02 618.64 54.02 618.64 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="618.64"
					y1="53.53"
					x2="664.19"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.19"
					y1="53.53"
					x2="664.19"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.19"
					y1="54.02"
					x2="618.64"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.64"
					y1="54.02"
					x2="618.64"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.21"
					y1="59.44"
					x2="620.61"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.61"
					y1="54.02"
					x2="662.21"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="666.65 59.44 662.21 59.44 662.21 54.02 666.65 54.02 666.65 59.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="666.65"
					y1="59.44"
					x2="662.21"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.21"
					y1="59.44"
					x2="662.21"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.21"
					y1="54.02"
					x2="666.65"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.65"
					y1="54.02"
					x2="666.65"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="616.18 54.02 620.61 54.02 620.61 59.44 616.18 59.44 616.18 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="616.18"
					y1="54.02"
					x2="620.61"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.61"
					y1="54.02"
					x2="620.61"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.61"
					y1="59.44"
					x2="616.18"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.18"
					y1="59.44"
					x2="616.18"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.21"
					y1="55.01"
					x2="620.61"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="668.61 58.94 666.65 58.94 666.65 54.02 664.19 54.02 664.19 53.53 668.61 53.53 668.61 58.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="668.61"
					y1="58.94"
					x2="666.65"
					y2="58.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.65"
					y1="58.94"
					x2="666.65"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.65"
					y1="54.02"
					x2="664.19"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.19"
					y1="54.02"
					x2="664.19"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.19"
					y1="53.53"
					x2="668.61"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.61"
					y1="53.53"
					x2="668.61"
					y2="58.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="614.21 53.53 618.64 53.53 618.64 54.02 616.18 54.02 616.18 58.94 614.21 58.94 614.21 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="614.21"
					y1="53.53"
					x2="618.64"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.64"
					y1="53.53"
					x2="618.64"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.64"
					y1="54.02"
					x2="616.18"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.18"
					y1="54.02"
					x2="616.18"
					y2="58.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.18"
					y1="58.94"
					x2="614.21"
					y2="58.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.21"
					y1="58.94"
					x2="614.21"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="609.21 55.01 614.21 55.01 614.21 70.01 609.21 70.01 609.21 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="614.21"
					y1="55.01"
					x2="609.21"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.21"
					y1="70.01"
					x2="614.21"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.21"
					y1="70.01"
					x2="614.21"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.21"
					y1="55.01"
					x2="609.21"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="673.62 55.01 673.62 70.01 668.61 70.01 668.61 55.01 673.62 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="673.62"
					y1="70.01"
					x2="673.62"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.61"
					y1="70.01"
					x2="673.62"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.61"
					y1="55.01"
					x2="668.61"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.62"
					y1="55.01"
					x2="668.61"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="476.98 55.01 481.98 55.01 481.98 70.01 476.98 70.01 476.98 55.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="481.98"
					y1="55.01"
					x2="476.98"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.98"
					y1="70.01"
					x2="481.98"
					y2="55.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.98"
					y1="70.01"
					x2="481.98"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.98"
					y1="55.01"
					x2="476.98"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.23"
					y1="806.01"
					x2="647.73"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.34"
					y1="806.01"
					x2="647.73"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.34"
					y1="784.97"
					x2="794.34"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="794.34"
					y1="784.97"
					x2="814.35"
					y2="784.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="871.4"
					y1="784.97"
					x2="814.35"
					y2="784.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="871.4"
					y1="636.09"
					x2="871.4"
					y2="784.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.35"
					y1="636.09"
					x2="871.4"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="673.62"
					y1="50"
					x2="673.62"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="399.85"
					y1="928.75"
					x2="399.85"
					y2="845.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="948.75"
					x2="625.03"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="928.75"
					x2="625.03"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="928.75"
					x2="621.28"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="526.25"
					y1="948.75"
					x2="522.5"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="526.25"
					y1="928.75"
					x2="522.5"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="526.25"
					y1="928.75"
					x2="526.25"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="948.75"
					x2="627.73"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="627.73"
					y1="928.75"
					x2="621.28"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="527.5 950 527.5 948.75 522.5 948.75 522.5 950 527.5 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="620.02 948.75 620.02 950 625.03 950 625.03 948.75 620.02 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="527.5 928.75 527.5 927.5 522.5 927.5 522.5 928.75 527.5 928.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="620.02 927.5 620.02 928.75 625.03 928.75 625.03 927.5 620.02 927.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="527.5"
					y1="950"
					x2="522.5"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.5"
					y1="950"
					x2="522.5"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.5"
					y1="948.75"
					x2="527.5"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.5"
					y1="948.75"
					x2="527.5"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.02"
					y1="948.75"
					x2="625.03"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.03"
					y1="948.75"
					x2="625.03"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.03"
					y1="950"
					x2="620.02"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.02"
					y1="950"
					x2="620.02"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.5"
					y1="928.75"
					x2="522.5"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.5"
					y1="928.75"
					x2="522.5"
					y2="927.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.5"
					y1="927.5"
					x2="527.5"
					y2="927.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.5"
					y1="927.5"
					x2="527.5"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.02"
					y1="927.5"
					x2="625.03"
					y2="927.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.03"
					y1="927.5"
					x2="625.03"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.03"
					y1="928.75"
					x2="620.02"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.02"
					y1="928.75"
					x2="620.02"
					y2="927.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="528.75 948.75 528.75 928.75 526.87 928.75 526.87 948.75 528.75 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="620.65 948.75 620.65 928.75 618.77 928.75 618.77 948.75 620.65 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="555.12 865.09 552.02 868.18 615.68 931.84 618.77 928.75 555.12 865.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="526.87"
					y1="928.75"
					x2="526.25"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.87"
					y1="948.75"
					x2="526.25"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.25"
					y1="928.75"
					x2="526.25"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.65"
					y1="928.75"
					x2="621.28"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.65"
					y1="948.75"
					x2="621.28"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.28"
					y1="928.75"
					x2="621.28"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.75"
					y1="948.75"
					x2="528.75"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.75"
					y1="928.75"
					x2="526.87"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.87"
					y1="928.75"
					x2="526.87"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.87"
					y1="948.75"
					x2="528.75"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.65"
					y1="948.75"
					x2="620.65"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.65"
					y1="928.75"
					x2="618.77"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.77"
					y1="928.75"
					x2="618.77"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.77"
					y1="948.75"
					x2="620.65"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.12"
					y1="865.09"
					x2="552.02"
					y2="868.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.02"
					y1="868.18"
					x2="615.68"
					y2="931.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.68"
					y1="931.84"
					x2="618.77"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.77"
					y1="928.75"
					x2="555.12"
					y2="865.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.25"
					y1="928.75"
					x2="526.25"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="526.25"
					y1="928.75"
					x2="526.25"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="526.25"
					y1="928.75"
					x2="522.5"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="526.25"
					y1="928.75"
					x2="522.5"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="526.25"
					y1="948.75"
					x2="522.5"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="526.25"
					y1="948.75"
					x2="522.5"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="928.75"
					x2="621.28"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="928.75"
					x2="621.28"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="928.75"
					x2="625.03"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="928.75"
					x2="625.03"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="948.75"
					x2="625.03"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="621.28"
					y1="948.75"
					x2="625.03"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="640.23"
					y1="806.01"
					x2="640.23"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="627.73"
					y1="623.58"
					x2="627.73"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="623.58"
					x2="642.76"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="636.09"
					x2="642.76"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="636.09"
					x2="646.51"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="623.58"
					x2="740.29"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="636.09"
					x2="740.29"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="636.09"
					x2="736.54"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="627.73"
					y1="623.58"
					x2="640.23"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="623.58"
					x2="640.23"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="640.23"
					y1="636.09"
					x2="646.51"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="636.09"
					x2="764.35"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="735.29 622.33 735.29 623.58 740.29 623.58 740.29 622.33 735.29 622.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="647.76 623.58 647.76 622.33 642.76 622.33 642.76 623.58 647.76 623.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="735.29 636.09 735.29 637.34 740.29 637.34 740.29 636.09 735.29 636.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="647.76 637.34 647.76 636.09 642.76 636.09 642.76 637.34 647.76 637.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="735.29"
					y1="622.33"
					x2="740.29"
					y2="622.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.29"
					y1="622.33"
					x2="740.29"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.29"
					y1="623.58"
					x2="735.29"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.29"
					y1="623.58"
					x2="735.29"
					y2="622.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.76"
					y1="623.58"
					x2="642.76"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.76"
					y1="623.58"
					x2="642.76"
					y2="622.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.76"
					y1="622.33"
					x2="647.76"
					y2="622.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.76"
					y1="622.33"
					x2="647.76"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.29"
					y1="636.09"
					x2="740.29"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.29"
					y1="636.09"
					x2="740.29"
					y2="637.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.29"
					y1="637.34"
					x2="735.29"
					y2="637.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.29"
					y1="637.34"
					x2="735.29"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.76"
					y1="637.34"
					x2="642.76"
					y2="637.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.76"
					y1="637.34"
					x2="642.76"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.76"
					y1="636.09"
					x2="647.76"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.76"
					y1="636.09"
					x2="647.76"
					y2="637.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="734.04 623.58 734.04 636.09 735.91 636.09 735.91 623.58 734.04 623.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="647.14 623.58 647.14 636.09 649.01 636.09 649.01 623.58 647.14 623.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="709.14 696.21 712.23 693.11 652.11 632.99 649.01 636.09 709.14 696.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="735.91"
					y1="636.09"
					x2="736.54"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.91"
					y1="623.58"
					x2="736.54"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.54"
					y1="636.09"
					x2="736.54"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.14"
					y1="636.09"
					x2="646.51"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.14"
					y1="623.58"
					x2="646.51"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.51"
					y1="636.09"
					x2="646.51"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.04"
					y1="623.58"
					x2="734.04"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.04"
					y1="636.09"
					x2="735.91"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.91"
					y1="636.09"
					x2="735.91"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.91"
					y1="623.58"
					x2="734.04"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.14"
					y1="623.58"
					x2="647.14"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.14"
					y1="636.09"
					x2="649.01"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.01"
					y1="636.09"
					x2="649.01"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.01"
					y1="623.58"
					x2="647.14"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.14"
					y1="696.21"
					x2="712.23"
					y2="693.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.23"
					y1="693.11"
					x2="652.11"
					y2="632.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.11"
					y1="632.99"
					x2="649.01"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.01"
					y1="636.09"
					x2="709.14"
					y2="696.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.54"
					y1="636.09"
					x2="736.54"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="636.09"
					x2="736.54"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="636.09"
					x2="740.29"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="636.09"
					x2="740.29"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="623.58"
					x2="740.29"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="736.54"
					y1="623.58"
					x2="740.29"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="636.09"
					x2="646.51"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="636.09"
					x2="646.51"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="636.09"
					x2="642.76"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="636.09"
					x2="642.76"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="623.58"
					x2="642.76"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="646.51"
					y1="623.58"
					x2="642.76"
					y2="623.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="399.85"
					y1="845.01"
					x2="424.16"
					y2="845.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="424.16"
					y1="845.01"
					x2="424.16"
					y2="832.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="424.16"
					y1="832.51"
					x2="424.16"
					y2="530.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="221"
					y1="558.85"
					x2="208.5"
					y2="558.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.5"
					y1="488.83"
					x2="208.5"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="221"
					y1="488.83"
					x2="221"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="221"
					y1="488.83"
					x2="208.5"
					y2="488.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.5"
					y1="474.68"
					x2="208.5"
					y2="488.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="207.25 490.08 208.5 490.08 208.5 485.08 207.25 485.08 207.25 490.08"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="221 490.08 222.25 490.08 222.25 485.08 221 485.08 221 490.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="207.25"
					y1="490.08"
					x2="207.25"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.25"
					y1="485.08"
					x2="208.5"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.5"
					y1="485.08"
					x2="208.5"
					y2="490.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.5"
					y1="490.08"
					x2="207.25"
					y2="490.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.25"
					y1="557.6"
					x2="208.5"
					y2="557.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="490.08"
					x2="221"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="485.08"
					x2="222.25"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.25"
					y1="485.08"
					x2="222.25"
					y2="490.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.25"
					y1="490.08"
					x2="221"
					y2="490.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="557.6"
					x2="222.25"
					y2="557.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="208.5 491.33 221 491.33 221 489.45 208.5 489.45 208.5 491.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="208.5 558.22 221 558.22 221 556.35 208.5 556.35 208.5 558.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="266.97 510.37 263.88 507.28 217.9 553.25 221 556.35 266.97 510.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221"
					y1="489.45"
					x2="221"
					y2="488.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.5"
					y1="489.45"
					x2="208.5"
					y2="488.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="488.83"
					x2="208.5"
					y2="488.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="558.22"
					x2="221"
					y2="558.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.5"
					y1="558.22"
					x2="208.5"
					y2="558.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="558.85"
					x2="208.5"
					y2="558.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.5"
					y1="491.33"
					x2="221"
					y2="491.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="491.33"
					x2="221"
					y2="489.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="489.45"
					x2="208.5"
					y2="489.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.5"
					y1="489.45"
					x2="208.5"
					y2="491.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.5"
					y1="558.22"
					x2="221"
					y2="558.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="558.22"
					x2="221"
					y2="556.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="556.35"
					x2="208.5"
					y2="556.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.5"
					y1="556.35"
					x2="208.5"
					y2="558.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.97"
					y1="510.37"
					x2="263.88"
					y2="507.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.88"
					y1="507.28"
					x2="217.9"
					y2="553.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.9"
					y1="553.25"
					x2="221"
					y2="556.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="556.35"
					x2="266.97"
					y2="510.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="488.83"
					x2="208.5"
					y2="488.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="221"
					y1="488.83"
					x2="208.5"
					y2="488.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="221"
					y1="488.83"
					x2="221"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="221"
					y1="488.83"
					x2="221"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.5"
					y1="488.83"
					x2="208.5"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="208.5"
					y1="488.83"
					x2="208.5"
					y2="485.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="221"
					y1="558.85"
					x2="208.5"
					y2="558.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="221"
					y1="558.85"
					x2="208.5"
					y2="558.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="382.1"
					x2="145.02"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="379.6"
					x2="148.15"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="369.59"
					x2="145.02"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="369.59"
					x2="148.15"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="382.1"
					x2="267.56"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="379.6"
					x2="264.43"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="369.59"
					x2="267.56"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="369.59"
					x2="264.43"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="275.89"
					y1="369.59"
					x2="264.43"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="382.1"
					x2="275.89"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="262.56 379.6 262.56 382.1 263.81 382.1 263.81 379.6 262.56 379.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="262.56 383.35 267.56 383.35 267.56 382.1 262.56 382.1 262.56 383.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="148.78 379.6 148.78 382.1 150.03 382.1 150.03 379.6 148.78 379.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="150.03 382.1 145.02 382.1 145.02 383.35 150.03 383.35 150.03 382.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="262.56 369.59 267.56 369.59 267.56 366.47 262.56 366.47 262.56 369.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="150.03 366.47 145.02 366.47 145.02 369.59 150.03 369.59 150.03 366.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="262.56"
					y1="379.6"
					x2="262.56"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.56"
					y1="382.1"
					x2="263.81"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.81"
					y1="382.1"
					x2="263.81"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.81"
					y1="379.6"
					x2="262.56"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.56"
					y1="383.35"
					x2="267.56"
					y2="383.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.56"
					y1="383.35"
					x2="267.56"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.56"
					y1="382.1"
					x2="262.56"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.56"
					y1="382.1"
					x2="262.56"
					y2="383.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.78"
					y1="379.6"
					x2="148.78"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.78"
					y1="382.1"
					x2="150.03"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.03"
					y1="382.1"
					x2="150.03"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.03"
					y1="379.6"
					x2="148.78"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.03"
					y1="382.1"
					x2="145.02"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="145.02"
					y1="382.1"
					x2="145.02"
					y2="383.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="145.02"
					y1="383.35"
					x2="150.03"
					y2="383.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.03"
					y1="383.35"
					x2="150.03"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.56"
					y1="369.59"
					x2="267.56"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.56"
					y1="369.59"
					x2="267.56"
					y2="366.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.56"
					y1="366.47"
					x2="262.56"
					y2="366.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.56"
					y1="366.47"
					x2="262.56"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.03"
					y1="366.47"
					x2="145.02"
					y2="366.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="145.02"
					y1="366.47"
					x2="145.02"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="145.02"
					y1="369.59"
					x2="150.03"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.03"
					y1="369.59"
					x2="150.03"
					y2="366.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="258.81 379.6 263.81 379.6 263.81 369.59 258.81 369.59 258.81 379.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="148.78 379.6 153.78 379.6 153.78 369.59 148.78 369.59 148.78 379.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="208.79 369.59 153.78 369.59 153.78 373.97 208.79 373.97 208.79 369.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="228.8 373.97 173.78 373.97 173.78 378.34 228.8 378.34 228.8 373.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="263.81"
					y1="369.59"
					x2="264.43"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.81"
					y1="379.6"
					x2="264.43"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.43"
					y1="369.59"
					x2="264.43"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.78"
					y1="369.59"
					x2="148.15"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.78"
					y1="379.6"
					x2="148.15"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.15"
					y1="369.59"
					x2="148.15"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.81"
					y1="379.6"
					x2="258.81"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.81"
					y1="369.59"
					x2="263.81"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.81"
					y1="369.59"
					x2="263.81"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.81"
					y1="379.6"
					x2="258.81"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.78"
					y1="379.6"
					x2="148.78"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.78"
					y1="369.59"
					x2="153.78"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.78"
					y1="369.59"
					x2="153.78"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.78"
					y1="379.6"
					x2="148.78"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.79"
					y1="369.59"
					x2="208.79"
					y2="373.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.79"
					y1="373.97"
					x2="153.78"
					y2="373.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.78"
					y1="373.97"
					x2="153.78"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.78"
					y1="369.59"
					x2="208.79"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.8"
					y1="373.97"
					x2="228.8"
					y2="378.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.8"
					y1="378.34"
					x2="173.78"
					y2="378.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.78"
					y1="378.34"
					x2="173.78"
					y2="373.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.78"
					y1="373.97"
					x2="228.8"
					y2="373.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.43"
					y1="369.59"
					x2="264.43"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="369.59"
					x2="264.43"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="379.6"
					x2="264.43"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="369.59"
					x2="267.56"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="379.6"
					x2="264.43"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="382.1"
					x2="267.56"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="264.43"
					y1="382.1"
					x2="267.56"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="369.59"
					x2="148.15"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="369.59"
					x2="148.15"
					y2="379.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="379.6"
					x2="148.15"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="369.59"
					x2="145.02"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="379.6"
					x2="148.15"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="382.1"
					x2="145.02"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="148.15"
					y1="382.1"
					x2="145.02"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="382.1"
					x2="422.1"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="369.59"
					x2="422.1"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="369.59"
					x2="418.35"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="328.33"
					y1="382.1"
					x2="324.58"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="328.33"
					y1="369.59"
					x2="324.58"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="328.33"
					y1="369.59"
					x2="328.33"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="329.58 383.35 329.58 382.1 324.58 382.1 324.58 383.35 329.58 383.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="417.1 382.1 417.1 383.35 422.1 383.35 422.1 382.1 417.1 382.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.58 369.59 329.58 368.34 324.58 368.34 324.58 369.59 329.58 369.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="417.1 368.34 417.1 369.59 422.1 369.59 422.1 368.34 417.1 368.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="329.58"
					y1="383.35"
					x2="324.58"
					y2="383.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.58"
					y1="383.35"
					x2="324.58"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.58"
					y1="382.1"
					x2="329.58"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.58"
					y1="382.1"
					x2="329.58"
					y2="383.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="382.1"
					x2="422.1"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.1"
					y1="382.1"
					x2="422.1"
					y2="383.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.1"
					y1="383.35"
					x2="417.1"
					y2="383.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="383.35"
					x2="417.1"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.58"
					y1="369.59"
					x2="324.58"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.58"
					y1="369.59"
					x2="324.58"
					y2="368.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.58"
					y1="368.34"
					x2="329.58"
					y2="368.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.58"
					y1="368.34"
					x2="329.58"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="368.34"
					x2="422.1"
					y2="368.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.1"
					y1="368.34"
					x2="422.1"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.1"
					y1="369.59"
					x2="417.1"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.1"
					y1="369.59"
					x2="417.1"
					y2="368.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="330.83 382.1 330.83 369.59 328.95 369.59 328.95 382.1 330.83 382.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="417.73 382.1 417.73 369.59 415.85 369.59 415.85 382.1 417.73 382.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="355.73 309.47 352.64 312.57 412.76 372.69 415.85 369.59 355.73 309.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="328.95"
					y1="369.59"
					x2="328.33"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.95"
					y1="382.1"
					x2="328.33"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.33"
					y1="369.59"
					x2="328.33"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.73"
					y1="369.59"
					x2="418.35"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.73"
					y1="382.1"
					x2="418.35"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.35"
					y1="369.59"
					x2="418.35"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.83"
					y1="382.1"
					x2="330.83"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.83"
					y1="369.59"
					x2="328.95"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.95"
					y1="369.59"
					x2="328.95"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.95"
					y1="382.1"
					x2="330.83"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.73"
					y1="382.1"
					x2="417.73"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.73"
					y1="369.59"
					x2="415.85"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.85"
					y1="369.59"
					x2="415.85"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.85"
					y1="382.1"
					x2="417.73"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.73"
					y1="309.47"
					x2="352.64"
					y2="312.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.64"
					y1="312.57"
					x2="412.76"
					y2="372.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.76"
					y1="372.69"
					x2="415.85"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.85"
					y1="369.59"
					x2="355.73"
					y2="309.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.33"
					y1="369.59"
					x2="328.33"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="328.33"
					y1="369.59"
					x2="328.33"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="328.33"
					y1="369.59"
					x2="324.58"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="328.33"
					y1="369.59"
					x2="324.58"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="328.33"
					y1="382.1"
					x2="324.58"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="328.33"
					y1="382.1"
					x2="324.58"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="369.59"
					x2="418.35"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="369.59"
					x2="418.35"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="369.59"
					x2="422.1"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="369.59"
					x2="422.1"
					y2="369.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="382.1"
					x2="422.1"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="418.35"
					y1="382.1"
					x2="422.1"
					y2="382.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="128.59"
					y1="474.68"
					x2="208.5"
					y2="474.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="488.35"
					x2="763.44"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="490.85"
					x2="760.32"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="500.86"
					x2="763.44"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="500.86"
					x2="760.32"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="488.35"
					x2="640.91"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="490.85"
					x2="644.04"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="500.86"
					x2="640.91"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="500.86"
					x2="644.04"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="640.23"
					y1="500.86"
					x2="644.04"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="500.86"
					x2="764.35"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.35"
					y1="488.35"
					x2="760.32"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="488.35"
					x2="640.23"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="645.91 490.85 645.91 488.35 644.66 488.35 644.66 490.85 645.91 490.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="645.91 487.1 640.91 487.1 640.91 488.35 645.91 488.35 645.91 487.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="759.69 490.85 759.69 488.35 758.44 488.35 758.44 490.85 759.69 490.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="758.44 488.35 763.44 488.35 763.44 487.1 758.44 487.1 758.44 488.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="645.91 500.86 640.91 500.86 640.91 503.98 645.91 503.98 645.91 500.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="758.44 503.98 763.44 503.98 763.44 500.86 758.44 500.86 758.44 503.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="645.91"
					y1="490.85"
					x2="645.91"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.91"
					y1="488.35"
					x2="644.66"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.66"
					y1="488.35"
					x2="644.66"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.66"
					y1="490.85"
					x2="645.91"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.91"
					y1="487.1"
					x2="640.91"
					y2="487.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.91"
					y1="487.1"
					x2="640.91"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.91"
					y1="488.35"
					x2="645.91"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.91"
					y1="488.35"
					x2="645.91"
					y2="487.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.69"
					y1="490.85"
					x2="759.69"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.69"
					y1="488.35"
					x2="758.44"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.44"
					y1="488.35"
					x2="758.44"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.44"
					y1="490.85"
					x2="759.69"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.44"
					y1="488.35"
					x2="763.44"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.44"
					y1="488.35"
					x2="763.44"
					y2="487.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.44"
					y1="487.1"
					x2="758.44"
					y2="487.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.44"
					y1="487.1"
					x2="758.44"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.91"
					y1="500.86"
					x2="640.91"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.91"
					y1="500.86"
					x2="640.91"
					y2="503.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.91"
					y1="503.98"
					x2="645.91"
					y2="503.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.91"
					y1="503.98"
					x2="645.91"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.44"
					y1="503.98"
					x2="763.44"
					y2="503.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.44"
					y1="503.98"
					x2="763.44"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.44"
					y1="500.86"
					x2="758.44"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.44"
					y1="500.86"
					x2="758.44"
					y2="503.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="649.66 490.85 644.66 490.85 644.66 500.86 649.66 500.86 649.66 490.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="759.69 490.85 754.69 490.85 754.69 500.86 759.69 500.86 759.69 490.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="699.67 500.86 754.69 500.86 754.69 496.48 699.67 496.48 699.67 500.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="679.67 496.48 734.68 496.48 734.68 492.1 679.67 492.1 679.67 496.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="644.66"
					y1="500.86"
					x2="644.04"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.66"
					y1="490.85"
					x2="644.04"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.04"
					y1="500.86"
					x2="644.04"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.69"
					y1="500.86"
					x2="760.32"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.69"
					y1="490.85"
					x2="760.32"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.32"
					y1="500.86"
					x2="760.32"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.66"
					y1="490.85"
					x2="649.66"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.66"
					y1="500.86"
					x2="644.66"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.66"
					y1="500.86"
					x2="644.66"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.66"
					y1="490.85"
					x2="649.66"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.69"
					y1="490.85"
					x2="759.69"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.69"
					y1="500.86"
					x2="754.69"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.69"
					y1="500.86"
					x2="754.69"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.69"
					y1="490.85"
					x2="759.69"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.67"
					y1="500.86"
					x2="699.67"
					y2="496.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.67"
					y1="496.48"
					x2="754.69"
					y2="496.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.69"
					y1="496.48"
					x2="754.69"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.69"
					y1="500.86"
					x2="699.67"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.67"
					y1="496.48"
					x2="679.67"
					y2="492.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.67"
					y1="492.1"
					x2="734.68"
					y2="492.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.68"
					y1="492.1"
					x2="734.68"
					y2="496.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.68"
					y1="496.48"
					x2="679.67"
					y2="496.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.04"
					y1="500.86"
					x2="644.04"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="500.86"
					x2="644.04"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="490.85"
					x2="644.04"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="500.86"
					x2="640.91"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="490.85"
					x2="644.04"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="488.35"
					x2="640.91"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.04"
					y1="488.35"
					x2="640.91"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="500.86"
					x2="760.32"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="500.86"
					x2="760.32"
					y2="490.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="490.85"
					x2="760.32"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="500.86"
					x2="763.44"
					y2="500.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="490.85"
					x2="760.32"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="488.35"
					x2="763.44"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="760.32"
					y1="488.35"
					x2="763.44"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="177.51"
					y1="50"
					x2="177.51"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="344"
					y1="50"
					x2="344"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="476.98"
					y1="70.01"
					x2="476.98"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="692.22 740.34 687.75 738.35 682.92 737.66 678.08 738.35 673.62 740.34 670.68 742.87 668.45 746.04 665.61 753.48 664.61 759.66 664.99 765.91 666.72 771.93 666.58 777.43 665.18 782.75 662.61 787.62 661.27 789.74 659.68 794.08 659.92 798.7 660.63 800.53 660.63 805.38 662.66 805.38 662.66 803.17 666.05 805.22 669.93 806.01 695.9 806.01 700.93 804.66 704.7 801.08 706.31 796.15 706.31 795.55 705.8 792.42 703.16 787.51 700.61 782.7 699.23 777.43 699.09 771.99 700.84 765.95 701.22 759.69 700.22 753.48 697.39 746.04 695.16 742.87 692.22 740.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="673.66"
					y1="782.92"
					x2="692.18"
					y2="782.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.9"
					y1="806.01"
					x2="682.92"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.9"
					y1="805.08"
					x2="682.92"
					y2="805.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.93"
					y1="806.01"
					x2="682.92"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.93"
					y1="805.08"
					x2="682.92"
					y2="805.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.69"
					y1="782.92"
					x2="691.69"
					y2="786.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.69"
					y1="786.38"
					x2="688.83"
					y2="786.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.83"
					y1="786.38"
					x2="688.83"
					y2="782.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.14"
					y1="782.92"
					x2="674.14"
					y2="786.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.14"
					y1="786.38"
					x2="677"
					y2="786.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677"
					y1="786.38"
					x2="677"
					y2="782.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.66"
					y1="796.78"
					x2="662.66"
					y2="805.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.63"
					y1="796.78"
					x2="660.63"
					y2="805.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.63"
					y1="805.38"
					x2="662.66"
					y2="805.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.63"
					y1="796.78"
					x2="662.66"
					y2="796.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.92"
					y1="737.66"
					x2="686.02"
					y2="738.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.02"
					y1="738.01"
					x2="689.02"
					y2="738.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.02"
					y1="738.82"
					x2="692.22"
					y2="740.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.22"
					y1="740.34"
					x2="695.16"
					y2="742.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.16"
					y1="742.87"
					x2="697.39"
					y2="746.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.39"
					y1="746.04"
					x2="699.03"
					y2="749.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.03"
					y1="749.65"
					x2="700.22"
					y2="753.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.22"
					y1="753.48"
					x2="701.3"
					y2="759.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.3"
					y1="759.68"
					x2="701.36"
					y2="762.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.36"
					y1="762.8"
					x2="701.01"
					y2="765.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.01"
					y1="765.91"
					x2="699.6"
					y2="770.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.6"
					y1="770.74"
					x2="697.42"
					y2="775.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.42"
					y1="775.41"
					x2="694.81"
					y2="779.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.81"
					y1="779.58"
					x2="692.18"
					y2="782.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.09"
					y1="771.99"
					x2="699.12"
					y2="776.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.12"
					y1="776.32"
					x2="699.83"
					y2="780.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.83"
					y1="780.54"
					x2="700.57"
					y2="782.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.57"
					y1="782.81"
					x2="701.62"
					y2="785.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.62"
					y1="785.06"
					x2="703.71"
					y2="788.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.71"
					y1="788.34"
					x2="705.55"
					y2="791.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.55"
					y1="791.73"
					x2="706.29"
					y2="795.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.29"
					y1="795.04"
					x2="706.01"
					y2="798.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.01"
					y1="798.34"
					x2="704.73"
					y2="801.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.73"
					y1="801.34"
					x2="703.71"
					y2="802.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.71"
					y1="802.64"
					x2="702.46"
					y2="803.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.46"
					y1="803.75"
					x2="700.24"
					y2="804.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.24"
					y1="804.98"
					x2="698.12"
					y2="805.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.12"
					y1="805.66"
					x2="695.9"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.9"
					y1="805.08"
					x2="696.9"
					y2="804.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.9"
					y1="804.98"
					x2="698.94"
					y2="804.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.94"
					y1="804.35"
					x2="700.74"
					y2="802.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.74"
					y1="802.83"
					x2="701.88"
					y2="800.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.88"
					y1="800.71"
					x2="702.41"
					y2="797.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.41"
					y1="797.92"
					x2="702.54"
					y2="795.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.54"
					y1="795.05"
					x2="702.52"
					y2="793.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.52"
					y1="793.62"
					x2="701.92"
					y2="792.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.92"
					y1="792.49"
					x2="701.21"
					y2="792.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.21"
					y1="792.16"
					x2="693.35"
					y2="789.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.35"
					y1="789.92"
					x2="689.45"
					y2="789.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.45"
					y1="789.26"
					x2="685.5"
					y2="788.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.5"
					y1="788.97"
					x2="682.92"
					y2="788.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.72"
					y1="771.93"
					x2="666.68"
					y2="776.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.68"
					y1="776.27"
					x2="665.97"
					y2="780.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.97"
					y1="780.51"
					x2="665.25"
					y2="782.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.25"
					y1="782.8"
					x2="664.21"
					y2="785.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.21"
					y1="785.06"
					x2="662.13"
					y2="788.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.13"
					y1="788.35"
					x2="660.28"
					y2="791.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.28"
					y1="791.73"
					x2="659.67"
					y2="793.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.67"
					y1="793.94"
					x2="659.53"
					y2="796.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.53"
					y1="796.21"
					x2="659.85"
					y2="798.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.85"
					y1="798.44"
					x2="660.63"
					y2="800.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.93"
					y1="805.08"
					x2="668.94"
					y2="804.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.94"
					y1="804.98"
					x2="666.9"
					y2="804.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.9"
					y1="804.35"
					x2="665.09"
					y2="802.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.09"
					y1="802.83"
					x2="663.96"
					y2="800.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.96"
					y1="800.71"
					x2="663.42"
					y2="797.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.42"
					y1="797.92"
					x2="663.3"
					y2="795.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.3"
					y1="795.05"
					x2="663.31"
					y2="793.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.31"
					y1="793.62"
					x2="663.92"
					y2="792.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.92"
					y1="792.49"
					x2="664.62"
					y2="792.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.62"
					y1="792.16"
					x2="672.48"
					y2="789.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.48"
					y1="789.92"
					x2="676.38"
					y2="789.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.38"
					y1="789.26"
					x2="680.34"
					y2="788.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.34"
					y1="788.97"
					x2="682.92"
					y2="788.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.92"
					y1="737.66"
					x2="679.82"
					y2="738.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.82"
					y1="738.01"
					x2="676.81"
					y2="738.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.81"
					y1="738.82"
					x2="673.62"
					y2="740.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.62"
					y1="740.34"
					x2="670.67"
					y2="742.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.67"
					y1="742.87"
					x2="668.45"
					y2="746.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.45"
					y1="746.04"
					x2="666.8"
					y2="749.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.8"
					y1="749.65"
					x2="665.61"
					y2="753.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.61"
					y1="753.48"
					x2="664.53"
					y2="759.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.53"
					y1="759.68"
					x2="664.48"
					y2="762.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.48"
					y1="762.8"
					x2="664.82"
					y2="765.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.82"
					y1="765.91"
					x2="666.23"
					y2="770.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.23"
					y1="770.74"
					x2="668.42"
					y2="775.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.42"
					y1="775.41"
					x2="671.02"
					y2="779.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.02"
					y1="779.58"
					x2="673.66"
					y2="782.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.68"
					y1="789.93"
					x2="704.19"
					y2="789.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.19"
					y1="789.22"
					x2="702.76"
					y2="788.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.76"
					y1="788.17"
					x2="701.52"
					y2="787.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.52"
					y1="787.92"
					x2="693.54"
					y2="787.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.54"
					y1="787.24"
					x2="685.54"
					y2="786.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.54"
					y1="786.93"
					x2="682.92"
					y2="786.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.15"
					y1="789.93"
					x2="661.65"
					y2="789.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.65"
					y1="789.22"
					x2="663.08"
					y2="788.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.08"
					y1="788.17"
					x2="664.32"
					y2="787.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.32"
					y1="787.92"
					x2="672.3"
					y2="787.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.3"
					y1="787.24"
					x2="680.3"
					y2="786.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.3"
					y1="786.93"
					x2="682.92"
					y2="786.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.66"
					y1="803.17"
					x2="663.38"
					y2="803.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.38"
					y1="803.75"
					x2="665.59"
					y2="804.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.59"
					y1="804.98"
					x2="667.71"
					y2="805.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.71"
					y1="805.66"
					x2="669.93"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="712.92 806.01 712.92 805.01 707.93 805.01 707.93 806.01 712.92 806.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="707.93"
					y1="806.01"
					x2="712.92"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.93"
					y1="805.01"
					x2="707.93"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.92"
					y1="805.01"
					x2="707.93"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.92"
					y1="806.01"
					x2="712.92"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="652.91 806.01 657.91 806.01 657.91 805.01 652.91 805.01 652.91 806.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="652.91"
					y1="805.01"
					x2="652.91"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.91"
					y1="805.01"
					x2="652.91"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.91"
					y1="806.01"
					x2="657.91"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.91"
					y1="806.01"
					x2="657.91"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="710.93 805.01 710.93 796.87 709.92 796.87 709.92 805.01 710.93 805.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="709.92"
					y1="805.01"
					x2="710.93"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.92"
					y1="796.87"
					x2="709.92"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.93"
					y1="796.87"
					x2="709.92"
					y2="796.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.93"
					y1="805.01"
					x2="710.93"
					y2="796.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="654.91 805.01 655.91 805.01 655.91 796.87 654.91 796.87 654.91 805.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="654.91"
					y1="796.87"
					x2="654.91"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.91"
					y1="796.87"
					x2="654.91"
					y2="796.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.91"
					y1="805.01"
					x2="655.91"
					y2="796.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.91"
					y1="805.01"
					x2="655.91"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="709.92 799.37 709.92 797.38 655.91 797.38 655.91 799.37 709.92 799.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="655.91"
					y1="799.37"
					x2="709.92"
					y2="799.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.91"
					y1="797.38"
					x2="655.91"
					y2="799.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.92"
					y1="797.38"
					x2="655.91"
					y2="797.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.92"
					y1="799.37"
					x2="709.92"
					y2="797.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="794.34 784.97 871.4 784.97 871.4 636.09 794.34 636.09 794.34 784.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="794.34"
					y1="636.09"
					x2="794.34"
					y2="784.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.4"
					y1="636.09"
					x2="794.34"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.4"
					y1="784.97"
					x2="871.4"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.34"
					y1="784.97"
					x2="871.4"
					y2="784.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="803.47 775.65 861.27 775.65 861.27 646.05 803.47 646.05 803.47 775.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="803.47"
					y1="646.05"
					x2="803.47"
					y2="775.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.27"
					y1="646.05"
					x2="803.47"
					y2="646.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.27"
					y1="775.65"
					x2="861.27"
					y2="646.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.47"
					y1="775.65"
					x2="861.27"
					y2="775.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="832.88 762.91 832.35 762.95 831.85 763.08 831.38 763.29 830.95 763.58 830.59 763.93 830.29 764.33 830.07 764.78 829.93 765.26 829.89 765.75 829.93 766.25 830.07 766.73 830.29 767.17 830.59 767.58 830.95 767.93 831.38 768.21 831.85 768.42 832.35 768.55 832.88 768.6 833.39 768.55 833.9 768.42 834.37 768.21 834.8 767.93 835.16 767.58 835.46 767.17 835.68 766.73 835.82 766.25 835.86 765.75 835.82 765.26 835.68 764.78 835.46 764.33 835.16 763.93 834.8 763.58 834.37 763.29 833.9 763.08 833.39 762.95 832.88 762.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="833.39"
					y1="762.95"
					x2="832.88"
					y2="762.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.9"
					y1="763.08"
					x2="833.39"
					y2="762.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.37"
					y1="763.29"
					x2="833.9"
					y2="763.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.8"
					y1="763.58"
					x2="834.37"
					y2="763.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.16"
					y1="763.93"
					x2="834.8"
					y2="763.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.46"
					y1="764.33"
					x2="835.16"
					y2="763.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.68"
					y1="764.78"
					x2="835.46"
					y2="764.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.82"
					y1="765.26"
					x2="835.68"
					y2="764.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.86"
					y1="765.75"
					x2="835.82"
					y2="765.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.82"
					y1="766.25"
					x2="835.86"
					y2="765.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.68"
					y1="766.73"
					x2="835.82"
					y2="766.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.46"
					y1="767.17"
					x2="835.68"
					y2="766.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.16"
					y1="767.58"
					x2="835.46"
					y2="767.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.8"
					y1="767.93"
					x2="835.16"
					y2="767.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.37"
					y1="768.21"
					x2="834.8"
					y2="767.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.9"
					y1="768.42"
					x2="834.37"
					y2="768.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.39"
					y1="768.55"
					x2="833.9"
					y2="768.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.88"
					y1="768.6"
					x2="833.39"
					y2="768.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.35"
					y1="768.55"
					x2="832.88"
					y2="768.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.85"
					y1="768.42"
					x2="832.35"
					y2="768.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.38"
					y1="768.21"
					x2="831.85"
					y2="768.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.95"
					y1="767.93"
					x2="831.38"
					y2="768.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.59"
					y1="767.58"
					x2="830.95"
					y2="767.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.29"
					y1="767.17"
					x2="830.59"
					y2="767.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.07"
					y1="766.73"
					x2="830.29"
					y2="767.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.93"
					y1="766.25"
					x2="830.07"
					y2="766.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.89"
					y1="765.75"
					x2="829.93"
					y2="766.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.93"
					y1="765.26"
					x2="829.89"
					y2="765.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.07"
					y1="764.78"
					x2="829.93"
					y2="765.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.29"
					y1="764.33"
					x2="830.07"
					y2="764.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.59"
					y1="763.93"
					x2="830.29"
					y2="764.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.95"
					y1="763.58"
					x2="830.59"
					y2="763.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.38"
					y1="763.29"
					x2="830.95"
					y2="763.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.85"
					y1="763.08"
					x2="831.38"
					y2="763.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.35"
					y1="762.95"
					x2="831.85"
					y2="763.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.88"
					y1="762.91"
					x2="832.35"
					y2="762.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="835.45 778.97 835.41 779.4 835.3 779.81 835.11 780.2 834.85 780.55 834.53 780.85 834.16 781.1 833.76 781.28 833.32 781.39 832.88 781.42 832.43 781.39 831.99 781.28 831.59 781.1 831.22 780.85 830.9 780.55 830.64 780.2 830.45 779.81 830.34 779.4 830.3 778.97 830.71 774.85 830.77 774.53 830.88 774.22 831.05 773.92 831.73 768.73 831.77 768.54 831.84 768.37 831.95 768.21 832.08 768.07 832.23 767.96 832.4 767.87 832.58 767.8 832.78 767.77 832.97 767.77 833.17 767.8 833.35 767.87 833.52 767.96 833.67 768.07 833.8 768.21 833.9 768.37 833.98 768.54 834.02 768.73 834.7 773.92 834.87 774.22 834.98 774.53 835.04 774.85 835.45 778.97"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="835.45"
					y1="778.97"
					x2="835.04"
					y2="774.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.7"
					y1="773.92"
					x2="834.02"
					y2="768.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.73"
					y1="768.73"
					x2="831.05"
					y2="773.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.71"
					y1="774.85"
					x2="830.3"
					y2="778.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.47"
					y1="776.53"
					x2="831.47"
					y2="775.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.28"
					y1="775.07"
					x2="834.28"
					y2="776.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.28"
					y1="776.53"
					x2="831.47"
					y2="776.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m834.7,773.92c.19.28.3.6.34.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m831.73,768.73c.07-.55.56-.96,1.15-.96s1.07.41,1.14.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m830.71,774.85c.03-.33.15-.65.34-.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m835.45,778.97c0,1.36-1.15,2.45-2.58,2.45s-2.58-1.1-2.58-2.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m831.47,775.07c0-.74.63-1.33,1.4-1.33s1.4.6,1.4,1.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m831.05,773.92c.4-.59,1.09-.95,1.83-.95s1.43.36,1.83.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="481.23 609.54 424.16 609.54 424.16 665.62 481.23 665.62 481.23 609.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="481.23"
					y1="665.62"
					x2="481.23"
					y2="663.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="659.79"
					x2="481.23"
					y2="653.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="650.19"
					x2="481.23"
					y2="644.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="640.58"
					x2="481.23"
					y2="634.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="630.98"
					x2="481.23"
					y2="624.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="621.38"
					x2="481.23"
					y2="615.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="611.78"
					x2="481.23"
					y2="609.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="665.62"
					x2="426.89"
					y2="665.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.49"
					y1="665.62"
					x2="436.49"
					y2="665.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.1"
					y1="665.62"
					x2="446.1"
					y2="665.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.7"
					y1="665.62"
					x2="455.7"
					y2="665.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.3"
					y1="665.62"
					x2="465.3"
					y2="665.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.9"
					y1="665.62"
					x2="474.9"
					y2="665.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.5"
					y1="665.62"
					x2="481.23"
					y2="665.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="609.54"
					x2="424.16"
					y2="611.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="615.38"
					x2="424.16"
					y2="621.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="624.98"
					x2="424.16"
					y2="630.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="634.58"
					x2="424.16"
					y2="640.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="644.19"
					x2="424.16"
					y2="650.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="653.79"
					x2="424.16"
					y2="659.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="663.39"
					x2="424.16"
					y2="665.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="609.54"
					x2="478.5"
					y2="609.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.9"
					y1="609.54"
					x2="468.9"
					y2="609.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.3"
					y1="609.54"
					x2="459.3"
					y2="609.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.7"
					y1="609.54"
					x2="449.7"
					y2="609.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.1"
					y1="609.54"
					x2="440.1"
					y2="609.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.49"
					y1="609.54"
					x2="430.49"
					y2="609.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.89"
					y1="609.54"
					x2="424.16"
					y2="609.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="484.18 665.41 485.91 665.41 485.91 609.76 484.18 609.76 484.18 618.49 485.6 618.49 485.6 656.68 484.18 656.68 484.18 665.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="484.18"
					y1="656.68"
					x2="484.18"
					y2="665.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="485.6"
					y1="656.68"
					x2="484.18"
					y2="656.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="485.6"
					y1="618.49"
					x2="485.6"
					y2="656.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="484.18"
					y1="618.49"
					x2="485.6"
					y2="618.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="484.18"
					y1="609.76"
					x2="484.18"
					y2="618.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="485.91"
					y1="609.76"
					x2="484.18"
					y2="609.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="485.91"
					y1="665.41"
					x2="485.91"
					y2="609.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="484.18"
					y1="665.41"
					x2="485.91"
					y2="665.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="484.18 667.59 484.18 607.58 481.23 607.58 481.23 667.59 484.18 667.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="481.23"
					y1="667.59"
					x2="484.18"
					y2="667.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="481.23"
					y1="607.58"
					x2="481.23"
					y2="667.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="484.18"
					y1="607.58"
					x2="481.23"
					y2="607.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="484.18"
					y1="667.59"
					x2="484.18"
					y2="607.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="484.18"
					y1="609.76"
					x2="485.91"
					y2="609.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.91"
					y1="609.76"
					x2="485.91"
					y2="665.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.91"
					y1="665.41"
					x2="484.18"
					y2="665.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="607.58"
					x2="484.18"
					y2="667.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="656.68"
					x2="485.6"
					y2="656.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.6"
					y1="656.68"
					x2="485.6"
					y2="618.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.6"
					y1="618.49"
					x2="484.18"
					y2="618.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="607.58"
					x2="484.18"
					y2="607.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="667.59"
					x2="481.23"
					y2="667.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.23"
					y1="667.59"
					x2="481.23"
					y2="607.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="493.22 928.75 493.22 844.9 399.85 844.9 399.85 928.75 493.22 928.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="399.85"
					y1="928.75"
					x2="493.22"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.85"
					y1="844.9"
					x2="399.85"
					y2="928.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.22"
					y1="844.9"
					x2="399.85"
					y2="844.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.22"
					y1="928.75"
					x2="493.22"
					y2="844.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.97"
					y1="928.75"
					x2="486.97"
					y2="844.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="476.99 736.59 476.99 674.3 476.73 673.31 476.01 672.59 475.03 672.33 433.32 672.33 432.34 672.59 431.62 673.31 431.36 674.3 431.36 736.59 431.62 737.57 432.34 738.29 433.32 738.56 475.03 738.56 476.01 738.29 476.73 737.57 476.99 736.59"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m476.99,736.59c0,1.09-.88,1.97-1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.32"
					y1="738.56"
					x2="475.03"
					y2="738.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m433.32,738.56c-1.09,0-1.97-.88-1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.36"
					y1="674.3"
					x2="431.36"
					y2="736.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m431.36,674.3c0-1.09.88-1.97,1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.03"
					y1="672.33"
					x2="433.32"
					y2="672.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m475.03,672.33c1.09,0,1.97.88,1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.99"
					y1="736.59"
					x2="476.99"
					y2="674.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.07"
					y1="731.67"
					x2="472.07"
					y2="679.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.1"
					y1="677.25"
					x2="443.17"
					y2="677.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.2"
					y1="679.22"
					x2="441.2"
					y2="731.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.17"
					y1="733.64"
					x2="470.1"
					y2="733.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.07"
					y1="731.67"
					x2="472.07"
					y2="731.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m470.1,677.25c1.09,0,1.97.88,1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m441.2,679.22c0-1.09.88-1.97,1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m443.17,733.64c-1.09,0-1.97-.88-1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m472.07,731.67c0,1.09-.88,1.97-1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m454,705.44c0-1.63-1.32-2.95-2.95-2.95s-2.95,1.32-2.95,2.95,1.32,2.95,2.95,2.95,2.95-1.32,2.95-2.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="453.79 706.33 454.42 706.07 454.68 705.44 454.42 704.81 453.79 704.56 434.31 704.56 433.68 704.81 433.42 705.44 433.68 706.07 434.31 706.33 453.79 706.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="434.31"
					y1="706.33"
					x2="453.79"
					y2="706.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m434.31,706.33c-.49,0-.89-.4-.89-.89s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.79"
					y1="704.56"
					x2="434.31"
					y2="704.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m453.79,704.56h0c.49,0,.89.39.89.89s-.39.89-.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="439.33 707.41 439.33 706.33 434.31 706.33 433.68 706.07 433.42 705.44 433.68 704.81 434.31 704.56 439.33 704.56 439.33 703.48 432.93 703.48 432.93 707.41 439.33 707.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="432.93"
					y1="707.41"
					x2="439.33"
					y2="707.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.93"
					y1="703.48"
					x2="432.93"
					y2="707.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.33"
					y1="703.48"
					x2="432.93"
					y2="703.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.33"
					y1="704.56"
					x2="439.33"
					y2="703.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.31"
					y1="704.56"
					x2="439.33"
					y2="704.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m434.31,706.33c-.49,0-.89-.4-.89-.89s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.33"
					y1="706.33"
					x2="434.31"
					y2="706.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.33"
					y1="707.41"
					x2="439.33"
					y2="706.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="442.88 707.38 442.88 706.33 439.43 706.33 439.43 707.38 442.88 707.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="439.43"
					y1="707.38"
					x2="442.88"
					y2="707.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.43"
					y1="706.33"
					x2="439.43"
					y2="707.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.88"
					y1="706.33"
					x2="439.43"
					y2="706.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.88"
					y1="707.38"
					x2="442.88"
					y2="706.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="442.88 703.5 439.43 703.5 439.43 704.56 442.88 704.56 442.88 703.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="442.88"
					y1="704.56"
					x2="442.88"
					y2="703.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.43"
					y1="704.56"
					x2="442.88"
					y2="704.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.43"
					y1="703.5"
					x2="439.43"
					y2="704.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.88"
					y1="703.5"
					x2="439.43"
					y2="703.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="790.79 756.02 725.77 756.02 725.77 806.01 790.79 806.01 790.79 756.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="790.79"
					y1="756.02"
					x2="725.77"
					y2="756.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.79"
					y1="806.01"
					x2="725.77"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.77"
					y1="756.02"
					x2="725.77"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.79"
					y1="756.02"
					x2="790.79"
					y2="806.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.79"
					y1="804.04"
					x2="725.77"
					y2="804.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.29"
					y1="767.89"
					x2="733.27"
					y2="767.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.27"
					y1="767.89"
					x2="733.27"
					y2="797.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.27"
					y1="797.9"
					x2="783.29"
					y2="797.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.29"
					y1="797.9"
					x2="783.29"
					y2="767.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.26"
					y1="765.92"
					x2="731.31"
					y2="765.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.31"
					y1="765.92"
					x2="731.31"
					y2="799.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.31"
					y1="799.87"
					x2="785.26"
					y2="799.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.26"
					y1="799.87"
					x2="785.26"
					y2="765.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m761.24,791.12c0-1.63-1.32-2.95-2.95-2.95s-2.95,1.32-2.95,2.95,1.32,2.95,2.95,2.95,2.95-1.32,2.95-2.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="760.74 803.31 760.35 799.18 760.03 798.24 759.37 793.03 759.01 792.35 758.28 792.07 757.55 792.35 757.19 793.03 756.53 798.24 756.21 799.18 755.82 803.31 756.29 804.76 757.52 805.65 759.04 805.65 760.27 804.76 760.74 803.31"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m760.74,803.31c0,1.36-1.1,2.46-2.46,2.46s-2.46-1.1-2.46-2.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.21"
					y1="799.18"
					x2="755.82"
					y2="803.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m756.21,799.18c.03-.33.14-.66.32-.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.19"
					y1="793.03"
					x2="756.53"
					y2="798.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m757.19,793.03c.07-.55.54-.97,1.09-.97s1.02.41,1.09.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.03"
					y1="798.24"
					x2="759.37"
					y2="793.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m760.03,798.24c.18.28.29.6.32.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.74"
					y1="803.31"
					x2="760.35"
					y2="799.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.94"
					y1="800.86"
					x2="756.94"
					y2="799.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.62"
					y1="799.39"
					x2="759.62"
					y2="800.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.62"
					y1="800.86"
					x2="756.94"
					y2="800.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m756.94,799.39c0-.74.6-1.34,1.34-1.34s1.34.6,1.34,1.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m756.53,798.24c.38-.59,1.04-.95,1.75-.95s1.36.36,1.74.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.85"
					y1="502.78"
					x2="198.86"
					y2="502.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.86"
					y1="502.78"
					x2="198.86"
					y2="546.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.85"
					y1="493.63"
					x2="182.85"
					y2="555.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="141.66"
					y1="555.41"
					x2="141.66"
					y2="493.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="141.66"
					y1="493.63"
					x2="203.44"
					y2="493.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.44"
					y1="555.41"
					x2="141.66"
					y2="555.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.3"
					y1="493.63"
					x2="202.3"
					y2="555.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.85"
					y1="546.26"
					x2="198.86"
					y2="546.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.44"
					y1="493.63"
					x2="203.44"
					y2="555.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="845.01"
					x2="484.18"
					y2="530.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.22"
					y1="847.7"
					x2="498.75"
					y2="847.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.75"
					y1="847.7"
					x2="498.75"
					y2="850.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.75"
					y1="850.49"
					x2="493.22"
					y2="850.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="928.85"
					x2="484.18"
					y2="926.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="923.54"
					x2="484.18"
					y2="917.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="913.94"
					x2="484.18"
					y2="907.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="904.34"
					x2="484.18"
					y2="898.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="894.73"
					x2="484.18"
					y2="888.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="885.13"
					x2="484.18"
					y2="879.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="875.53"
					x2="484.18"
					y2="869.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="865.92"
					x2="484.18"
					y2="859.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="856.32"
					x2="484.18"
					y2="850.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="846.87"
					x2="484.18"
					y2="845.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.18"
					y1="530.9"
					x2="424.16"
					y2="530.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="177.51"
					y1="50"
					x2="344"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344"
					y1="70.01"
					x2="177.51"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.98"
					y1="50"
					x2="673.62"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.62"
					y1="70.01"
					x2="476.98"
					y2="70.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.52"
					y1="502.78"
					x2="148.52"
					y2="546.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.52"
					y1="546.26"
					x2="178.27"
					y2="546.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.27"
					y1="546.26"
					x2="178.27"
					y2="502.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.27"
					y1="502.78"
					x2="148.52"
					y2="502.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="489.18 818.32 489.18 743.29 424.16 743.29 424.16 818.32 489.18 818.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="489.18"
					y1="818.32"
					x2="489.18"
					y2="743.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="818.32"
					x2="424.16"
					y2="743.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.14"
					y1="818.32"
					x2="426.14"
					y2="743.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.18"
					y1="818.32"
					x2="424.16"
					y2="818.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.18"
					y1="743.29"
					x2="424.16"
					y2="743.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.23"
					y1="813.39"
					x2="486.23"
					y2="748.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.23"
					y1="748.22"
					x2="484.26"
					y2="746.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.26"
					y1="746.25"
					x2="429.09"
					y2="746.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.09"
					y1="746.25"
					x2="427.12"
					y2="748.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.12"
					y1="748.22"
					x2="427.12"
					y2="813.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.12"
					y1="813.39"
					x2="429.09"
					y2="815.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.09"
					y1="815.36"
					x2="484.26"
					y2="815.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.26"
					y1="815.36"
					x2="486.23"
					y2="813.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m482.78,799.56c0-5.44-4.41-9.85-9.85-9.85s-9.85,4.41-9.85,9.85,4.41,9.85,9.85,9.85,9.85-4.41,9.85-9.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m447.81,799.56c0-4.08-3.31-7.39-7.39-7.39s-7.38,3.31-7.38,7.39,3.31,7.38,7.38,7.38,7.39-3.31,7.39-7.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m480.32,762.05c0-4.08-3.31-7.38-7.39-7.38s-7.38,3.31-7.38,7.38,3.31,7.39,7.38,7.39,7.39-3.31,7.39-7.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m450.27,762.05c0-5.44-4.41-9.85-9.85-9.85s-9.85,4.41-9.85,9.85,4.41,9.85,9.85,9.85,9.85-4.41,9.85-9.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="845.01"
					x2="454.18"
					y2="843.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="839.8"
					x2="454.18"
					y2="833.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="830.2"
					x2="454.18"
					y2="824.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="820.6"
					x2="454.18"
					y2="814.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="810.99"
					x2="454.18"
					y2="804.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="801.39"
					x2="454.18"
					y2="795.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="791.78"
					x2="454.18"
					y2="785.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="782.18"
					x2="454.18"
					y2="776.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="772.58"
					x2="454.18"
					y2="766.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="762.98"
					x2="454.18"
					y2="756.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="753.38"
					x2="454.18"
					y2="747.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="743.77"
					x2="454.18"
					y2="737.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="734.17"
					x2="454.18"
					y2="728.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="724.57"
					x2="454.18"
					y2="718.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="714.96"
					x2="454.18"
					y2="708.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="705.36"
					x2="454.18"
					y2="699.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="695.76"
					x2="454.18"
					y2="689.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="686.15"
					x2="454.18"
					y2="680.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="676.55"
					x2="454.18"
					y2="670.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="666.95"
					x2="454.18"
					y2="660.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="657.35"
					x2="454.18"
					y2="651.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="647.75"
					x2="454.18"
					y2="641.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="638.14"
					x2="454.18"
					y2="632.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="628.54"
					x2="454.18"
					y2="622.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="618.93"
					x2="454.18"
					y2="612.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="609.33"
					x2="454.18"
					y2="603.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="599.73"
					x2="454.18"
					y2="593.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="590.13"
					x2="454.18"
					y2="584.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="580.52"
					x2="454.18"
					y2="574.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="570.92"
					x2="454.18"
					y2="564.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="561.32"
					x2="454.18"
					y2="555.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="551.72"
					x2="454.18"
					y2="545.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="542.11"
					x2="454.18"
					y2="536.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.18"
					y1="532.76"
					x2="454.18"
					y2="530.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="891.41 616.08 891.41 839.19 647.73 839.19 647.73 948.75 621.28 948.75 621.28 928.75 627.73 928.75 627.73 623.58 646.52 623.58 646.52 636.08 640.23 636.08 640.23 806.01 794.34 806.01 794.34 784.97 871.4 784.97 871.4 636.08 736.53 636.08 736.53 623.58 764.35 623.58 764.35 500.85 760.32 500.85 760.32 488.35 764.35 488.35 764.35 429.57 640.23 429.57 640.23 488.35 644.03 488.35 644.03 500.85 627.73 500.85 627.73 417.07 736.4 417.07 736.4 70.01 673.61 70.01 673.61 50 756.4 50 756.4 409.57 784.36 409.57 784.36 616.08 891.41 616.08"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.22"
				/>
				<polygon
					points="526.25 928.75 526.25 948.75 379.84 948.75 379.84 587.58 108.59 587.58 108.59 50 177.51 50 177.51 70.01 130.62 70.01 130.62 112.3 128.6 112.3 128.6 369.59 148.15 369.59 148.15 382.09 128.6 382.09 128.6 436.8 275.88 436.8 275.88 382.09 264.44 382.09 264.44 369.59 328.32 369.59 328.32 382.09 288.4 382.09 288.4 449.3 221.01 449.3 221.01 488.83 208.49 488.83 208.49 474.67 128.6 474.67 128.6 567.57 208.49 567.57 208.49 558.85 221.01 558.85 221.01 567.57 394.28 567.57 394.28 530.9 424.16 530.9 424.16 845.01 399.85 845.01 399.85 928.75 526.25 928.75"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.22"
				/>
				<polygon
					points="476.98 50 476.98 70.01 442.15 70.01 442.15 382.09 418.36 382.09 418.36 369.59 429.65 369.59 429.65 152.47 373.68 152.47 373.68 70.01 344 70.01 344 50 476.98 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.22"
				/>
			</g>
			<g id="text">
				<path d="m426.16,642.82v-11.6h4c.9,0,1.59.06,2.07.17.66.15,1.23.43,1.7.83.61.52,1.07,1.18,1.37,1.99.31.8.46,1.72.46,2.75,0,.88-.1,1.66-.31,2.34-.21.68-.47,1.25-.79,1.69-.32.44-.68.79-1.06,1.05-.38.25-.84.45-1.38.58-.54.13-1.16.2-1.86.2h-4.19Zm1.54-1.37h2.48c.77,0,1.36-.07,1.8-.21.44-.14.79-.34,1.04-.6.36-.36.65-.85.85-1.46.21-.62.31-1.36.31-2.24,0-1.21-.2-2.14-.6-2.79-.4-.65-.88-1.09-1.45-1.31-.41-.16-1.07-.24-1.99-.24h-2.44v8.86Zm12.19,1.37l-3.08-11.6h1.57l1.76,7.61c.19.8.35,1.59.49,2.37.3-1.24.47-1.95.52-2.14l2.21-7.84h1.85l1.66,5.87c.42,1.46.72,2.83.9,4.11.15-.73.34-1.57.58-2.52l1.82-7.46h1.54l-3.18,11.6h-1.48l-2.45-8.84c-.21-.74-.33-1.19-.36-1.36-.12.53-.23.99-.34,1.36l-2.46,8.84h-1.57Z" />
				<path d="m442.87,893.77h-1.63l-1.95-3.27c-.18-.3-.35-.56-.52-.77-.17-.22-.34-.39-.52-.53-.17-.14-.36-.23-.57-.29-.2-.07-.43-.1-.68-.1h-1.12v4.97h-1.37v-11.68h3.49c.51,0,.98.07,1.41.2.43.12.81.32,1.12.58.32.26.57.59.75.98.18.39.27.84.27,1.36,0,.41-.06.78-.19,1.12-.12.34-.29.64-.52.9-.22.27-.49.49-.81.68-.31.18-.67.33-1.07.43v.03c.2.09.36.19.5.3.15.11.29.24.42.39.13.15.26.33.38.52.13.19.27.41.43.67l2.19,3.51Zm-7-10.44v4.23h1.86c.34,0,.66-.05.94-.15.29-.1.55-.25.76-.44.21-.2.38-.43.5-.71.12-.28.18-.6.18-.94,0-.62-.2-1.11-.61-1.46-.4-.35-.99-.53-1.75-.53h-1.87Zm14.98,6.6h-5.89c.02.93.27,1.64.75,2.15.48.5,1.13.76,1.97.76.94,0,1.8-.31,2.59-.93v1.25c-.73.53-1.7.8-2.91.8s-2.1-.38-2.78-1.13c-.67-.76-1.01-1.83-1.01-3.2,0-1.3.37-2.35,1.1-3.17.74-.82,1.65-1.23,2.74-1.23s1.94.35,2.53,1.06c.6.71.9,1.69.9,2.94v.7Zm-1.37-1.13c0-.77-.19-1.37-.56-1.8-.36-.43-.87-.64-1.52-.64s-1.16.23-1.6.68c-.44.45-.71,1.04-.81,1.77h4.5Zm7.36-6.2c-.26-.15-.56-.22-.89-.22-.93,0-1.4.59-1.4,1.77v1.29h1.95v1.14h-1.95v7.2h-1.33v-7.2h-1.42v-1.14h1.42v-1.35c0-.87.25-1.56.76-2.07.5-.51,1.13-.77,1.89-.77.41,0,.73.05.97.15v1.21Z" />
				<path d="m458.25,893.95c-.25,0-.46-.09-.64-.27-.17-.18-.26-.39-.26-.64s.09-.46.26-.64c.18-.18.39-.28.64-.28s.47.09.65.28c.18.18.27.39.27.64s-.09.46-.27.64c-.18.18-.4.27-.65.27Z" />
				<path d="m732.7,706.84v-18.13h5.16c1.57,0,2.81.38,3.73,1.15.92.77,1.38,1.77,1.38,3,0,1.03-.28,1.92-.83,2.68-.56.76-1.32,1.3-2.3,1.62v.05c1.22.14,2.2.61,2.93,1.39.73.78,1.1,1.79,1.1,3.03,0,1.55-.56,2.81-1.67,3.77s-2.52,1.44-4.21,1.44h-5.28Zm2.12-16.2v5.85h2.17c1.16,0,2.08-.28,2.74-.83.67-.56,1-1.36,1-2.38,0-1.76-1.16-2.64-3.48-2.64h-2.44Zm0,7.76v6.52h2.88c1.25,0,2.21-.29,2.89-.88.69-.59,1.04-1.4,1.04-2.43,0-2.14-1.46-3.21-4.37-3.21h-2.44Zm21.7,8.44h-2.07v-2.02h-.05c-.9,1.55-2.23,2.33-3.98,2.33-1.29,0-2.3-.34-3.03-1.02-.72-.68-1.09-1.59-1.09-2.72,0-2.42,1.42-3.83,4.27-4.22l3.88-.54c0-2.2-.89-3.3-2.67-3.3-1.56,0-2.97.53-4.22,1.59v-2.12c1.27-.81,2.74-1.21,4.4-1.21,3.04,0,4.56,1.61,4.56,4.83v8.42Zm-2.07-6.55l-3.12.43c-.96.13-1.69.37-2.17.72-.49.34-.73.94-.73,1.81,0,.63.22,1.15.67,1.55.46.4,1.06.59,1.81.59,1.03,0,1.87-.36,2.54-1.07.67-.72,1.01-1.64,1.01-2.74v-1.29Zm11.99,6.42c-.49.27-1.13.4-1.93.4-2.27,0-3.4-1.26-3.4-3.79v-7.66h-2.22v-1.77h2.22v-3.16l2.07-.67v3.83h3.26v1.77h-3.26v7.29c0,.87.15,1.49.44,1.86.29.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm13.51.13h-2.07v-7.46c0-2.7-1-4.04-3.01-4.04-1.01,0-1.86.39-2.55,1.18-.69.78-1.04,1.77-1.04,3v7.33h-2.07v-19.16h2.07v8.37h.05c.99-1.63,2.41-2.45,4.25-2.45,2.92,0,4.37,1.76,4.37,5.27v7.98Z" />
				<path d="m543.37,842.2h-9.61v-18.13h9.2v1.92h-7.08v6.03h6.55v1.91h-6.55v6.35h7.48v1.92Zm13.98,0h-2.07v-7.38c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.38h-2.07v-12.94h2.07v2.15h.05c.98-1.63,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.12,2.23,1.12,3.96v7.91Zm9.93-.13c-.49.27-1.13.4-1.93.4-2.27,0-3.4-1.26-3.4-3.79v-7.66h-2.22v-1.77h2.22v-3.16l2.07-.67v3.83h3.26v1.77h-3.26v7.29c0,.87.15,1.49.44,1.86.29.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm9.54-10.72c-.36-.28-.88-.42-1.57-.42-.88,0-1.63.42-2.22,1.25-.59.83-.88,1.97-.88,3.41v6.6h-2.07v-12.94h2.07v2.67h.05c.29-.91.75-1.62,1.35-2.12.61-.51,1.29-.77,2.04-.77.54,0,.95.06,1.24.18v2.15Zm12.58-2.1l-5.95,15.02c-1.06,2.68-2.55,4.02-4.47,4.02-.54,0-.99-.05-1.35-.16v-1.86c.45.15.86.23,1.23.23,1.04,0,1.83-.62,2.35-1.87l1.04-2.45-5.06-12.92h2.3l3.5,9.96c.04.13.13.45.27.99h.08c.04-.2.13-.52.25-.96l3.68-9.99h2.15Z" />
				<path d="m228.94,218.04v-18.13h5.16c1.57,0,2.81.38,3.73,1.15.92.77,1.38,1.77,1.38,3,0,1.03-.28,1.92-.83,2.68-.56.76-1.32,1.3-2.3,1.62v.05c1.22.14,2.2.61,2.93,1.39.73.78,1.1,1.79,1.1,3.03,0,1.55-.56,2.81-1.67,3.77s-2.52,1.44-4.21,1.44h-5.28Zm2.12-16.2v5.85h2.17c1.16,0,2.08-.28,2.74-.83.67-.56,1-1.36,1-2.38,0-1.76-1.16-2.64-3.48-2.64h-2.44Zm0,7.76v6.52h2.88c1.25,0,2.21-.29,2.89-.88.69-.59,1.04-1.4,1.04-2.43,0-2.14-1.46-3.21-4.37-3.21h-2.44Zm22.81,2.49h-9.14c.03,1.44.42,2.55,1.16,3.34.74.78,1.76,1.18,3.06,1.18,1.46,0,2.8-.48,4.02-1.44v1.95c-1.14.83-2.64,1.24-4.51,1.24s-3.27-.59-4.31-1.76c-1.04-1.18-1.57-2.84-1.57-4.97,0-2.01.57-3.65,1.71-4.92,1.15-1.27,2.57-1.91,4.26-1.91s3,.55,3.93,1.64,1.39,2.62,1.39,4.56v1.09Zm-2.12-1.76c0-1.2-.3-2.13-.87-2.79-.56-.67-1.35-1-2.36-1s-1.81.35-2.49,1.05c-.68.7-1.1,1.61-1.26,2.74h6.99Zm16.29,7.71h-2.07v-2.2h-.05c-.96,1.67-2.44,2.5-4.45,2.5-1.63,0-2.93-.58-3.91-1.73-.97-1.16-1.45-2.74-1.45-4.74,0-2.14.54-3.86,1.62-5.14,1.08-1.29,2.52-1.93,4.31-1.93s3.07.7,3.88,2.1h.05v-8.01h2.07v19.16Zm-2.07-5.85v-1.91c0-1.04-.35-1.93-1.04-2.65-.69-.72-1.57-1.09-2.63-1.09-1.26,0-2.26.46-2.98,1.39-.72.93-1.09,2.21-1.09,3.84,0,1.49.35,2.67,1.04,3.54.7.86,1.63,1.29,2.81,1.29s2.09-.42,2.81-1.25c.72-.83,1.09-1.89,1.09-3.16Zm13-4.99c-.36-.28-.88-.42-1.57-.42-.88,0-1.63.42-2.22,1.25-.59.83-.88,1.97-.88,3.41v6.6h-2.07v-12.94h2.07v2.67h.05c.29-.91.75-1.62,1.35-2.12.61-.51,1.29-.77,2.04-.77.54,0,.95.06,1.24.18v2.15Zm7.65,11.15c-1.91,0-3.44-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.17.59-3.87,1.78-5.09,1.19-1.22,2.79-1.83,4.82-1.83s3.43.59,4.51,1.78c1.09,1.19,1.63,2.84,1.63,4.94s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.81c-1.33,0-2.38.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.74s.39,2.74,1.18,3.63c.78.88,1.83,1.33,3.15,1.33s2.37-.43,3.08-1.3c.72-.87,1.09-2.1,1.09-3.7s-.36-2.87-1.09-3.74c-.72-.88-1.74-1.31-3.08-1.31Zm15,11.81c-1.91,0-3.44-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.17.59-3.87,1.78-5.09,1.19-1.22,2.79-1.83,4.82-1.83s3.43.59,4.51,1.78c1.09,1.19,1.63,2.84,1.63,4.94s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.81c-1.33,0-2.38.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.74s.39,2.74,1.18,3.63c.78.88,1.83,1.33,3.15,1.33s2.37-.43,3.08-1.3c.72-.87,1.09-2.1,1.09-3.7s-.36-2.87-1.09-3.74c-.72-.88-1.74-1.31-3.08-1.31Zm27.97,11.5h-2.07v-7.43c0-1.43-.22-2.47-.67-3.11-.44-.64-1.18-.96-2.22-.96-.88,0-1.64.4-2.26,1.21-.62.81-.92,1.78-.92,2.91v7.38h-2.07v-7.69c0-2.54-.98-3.82-2.95-3.82-.91,0-1.66.38-2.25,1.15-.59.76-.88,1.75-.88,2.97v7.38h-2.07v-12.94h2.07v2.05h.05c.92-1.57,2.26-2.35,4.02-2.35.88,0,1.66.25,2.31.75.66.49,1.11,1.13,1.35,1.93.96-1.79,2.39-2.68,4.3-2.68,2.85,0,4.27,1.76,4.27,5.27v7.98Z" />
				<path d="m234.12,244.91h-1.51v-11.39c-.12.12-.29.25-.51.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Zm10.61-9.73c0-.4-.06-.76-.19-1.06-.12-.3-.29-.55-.52-.74-.21-.2-.47-.35-.76-.45-.29-.1-.61-.15-.96-.15-.29,0-.58.04-.86.12-.28.08-.56.19-.83.33-.26.14-.52.31-.77.51-.25.2-.48.41-.69.65v-1.62c.42-.41.9-.72,1.42-.94.53-.22,1.17-.33,1.92-.33.54,0,1.04.08,1.5.24.46.15.86.38,1.2.68.34.3.6.67.79,1.11.2.44.29.95.29,1.52,0,.52-.06.99-.18,1.42-.12.42-.3.82-.54,1.2-.24.37-.54.73-.91,1.08-.37.34-.8.69-1.3,1.05-.62.44-1.13.82-1.54,1.13-.4.31-.72.61-.96.88-.23.27-.4.54-.5.82-.09.27-.14.58-.14.94h6.57v1.35h-8.14v-.65c0-.56.06-1.06.18-1.49.12-.43.32-.84.61-1.22.28-.39.65-.77,1.1-1.16.46-.39,1.02-.82,1.68-1.31.48-.34.88-.67,1.2-.98.32-.31.59-.63.78-.94.2-.31.33-.63.41-.95.09-.32.13-.67.13-1.03Z" />
				<rect x="249.3" y="231.72" width="1.33" height="4.11" />
				<path d="m259.17,235.18c0-.4-.06-.76-.19-1.06-.12-.3-.29-.55-.51-.74-.21-.2-.47-.35-.76-.45-.29-.1-.61-.15-.96-.15-.29,0-.58.04-.86.12-.28.08-.56.19-.83.33-.26.14-.52.31-.77.51-.25.2-.48.41-.69.65v-1.62c.42-.41.9-.72,1.42-.94.53-.22,1.17-.33,1.92-.33.54,0,1.04.08,1.5.24.46.15.86.38,1.2.68.34.3.6.67.79,1.11.2.44.29.95.29,1.52,0,.52-.06.99-.18,1.42-.12.42-.3.82-.54,1.2-.24.37-.54.73-.91,1.08-.37.34-.8.69-1.3,1.05-.62.44-1.13.82-1.54,1.13-.4.31-.72.61-.96.88-.23.27-.4.54-.5.82-.09.27-.14.58-.14.94h6.57v1.35h-8.14v-.65c0-.56.06-1.06.18-1.49.12-.43.32-.84.61-1.22.28-.39.65-.77,1.1-1.16.46-.39,1.02-.82,1.68-1.31.48-.34.88-.67,1.2-.98.32-.31.59-.63.78-.94.2-.31.33-.63.41-.95.09-.32.13-.67.13-1.03Z" />
				<path d="m265.07,231.72v4.11h-1.33v-4.11h1.33Zm3.05,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m283.2,235.49l-3.16,4.76,3.11,4.65h-1.76l-1.85-3.05c-.12-.19-.25-.43-.41-.72h-.04c-.03.06-.17.29-.43.72l-1.89,3.05h-1.74l3.21-4.62-3.07-4.8h1.76l1.82,3.22c.13.24.27.48.4.74h.04l2.35-3.95h1.66Z" />
				<path d="m295.26,244.91h-1.51v-11.39c-.12.12-.29.25-.52.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Zm12.89-6.65c0,1.1-.1,2.08-.3,2.93-.2.85-.48,1.57-.86,2.16-.37.58-.84,1.03-1.39,1.33-.55.3-1.17.45-1.87.45-.66,0-1.25-.14-1.77-.43-.52-.29-.95-.72-1.31-1.28-.36-.56-.63-1.24-.81-2.05-.18-.82-.28-1.75-.28-2.8,0-1.15.1-2.17.29-3.05.2-.88.48-1.62.86-2.22.37-.6.84-1.05,1.39-1.35.56-.31,1.2-.46,1.91-.46,2.77,0,4.15,2.25,4.15,6.76Zm-1.55.15c0-3.75-.89-5.63-2.68-5.63-1.88,0-2.82,1.91-2.82,5.73,0,3.56.92,5.34,2.77,5.34s2.73-1.81,2.73-5.44Z" />
				<rect x="310.43" y="231.72" width="1.33" height="4.11" />
				<path d="m322.58,238.26c0,1.1-.1,2.08-.3,2.93-.2.85-.48,1.57-.86,2.16-.37.58-.84,1.03-1.39,1.33-.55.3-1.17.45-1.87.45-.66,0-1.25-.14-1.77-.43-.51-.29-.95-.72-1.31-1.28-.36-.56-.63-1.24-.81-2.05-.18-.82-.28-1.75-.28-2.8,0-1.15.1-2.17.29-3.05.2-.88.48-1.62.86-2.22.37-.6.84-1.05,1.39-1.35.56-.31,1.2-.46,1.91-.46,2.77,0,4.15,2.25,4.15,6.76Zm-1.55.15c0-3.75-.89-5.63-2.68-5.63-1.88,0-2.82,1.91-2.82,5.73,0,3.56.92,5.34,2.77,5.34s2.73-1.81,2.73-5.44Z" />
				<path d="m326.2,231.72v4.11h-1.33v-4.11h1.33Zm3.05,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m528.57,740.61h-2.96l-7-8.29c-.26-.31-.42-.52-.48-.63h-.05v8.92h-2.12v-18.13h2.12v8.52h.05c.12-.19.28-.39.48-.62l6.78-7.9h2.64l-7.77,8.7,8.32,9.43Zm3.17-16.23c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.23h-2.07v-12.94h2.07v12.94Zm10.18-.13c-.49.27-1.13.4-1.93.4-2.27,0-3.4-1.26-3.4-3.79v-7.66h-2.22v-1.77h2.22v-3.16l2.07-.67v3.83h3.26v1.77h-3.26v7.29c0,.87.15,1.49.44,1.86.29.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm11.58-.47c-.99.6-2.17.9-3.54.9-1.85,0-3.34-.6-4.47-1.79-1.13-1.2-1.69-2.76-1.69-4.68,0-2.13.61-3.84,1.83-5.13,1.22-1.3,2.85-1.95,4.89-1.95,1.14,0,2.14.21,3.01.63v2.12c-.96-.67-1.99-1.01-3.08-1.01-1.32,0-2.41.48-3.26,1.43-.84.94-1.26,2.19-1.26,3.73s.4,2.71,1.19,3.59c.8.88,1.87,1.31,3.21,1.31,1.13,0,2.19-.37,3.19-1.12v1.97Zm13.87.59h-2.07v-7.46c0-2.7-1-4.04-3.01-4.04-1.01,0-1.86.39-2.55,1.18-.69.78-1.04,1.77-1.04,3v7.33h-2.07v-19.16h2.07v8.37h.05c.99-1.63,2.41-2.45,4.25-2.45,2.92,0,4.37,1.76,4.37,5.27v7.98Zm14.29-5.95h-9.14c.03,1.44.42,2.55,1.16,3.34s1.76,1.18,3.06,1.18c1.46,0,2.8-.48,4.02-1.44v1.95c-1.14.83-2.64,1.24-4.51,1.24s-3.27-.59-4.31-1.76c-1.04-1.18-1.57-2.84-1.57-4.97,0-2.01.57-3.65,1.71-4.92,1.15-1.27,2.57-1.91,4.26-1.91s3,.55,3.93,1.64c.93,1.1,1.39,2.62,1.39,4.56v1.09Zm-2.12-1.76c0-1.2-.3-2.13-.87-2.79-.56-.67-1.35-1-2.36-1s-1.81.35-2.49,1.05c-.68.7-1.1,1.61-1.26,2.74h6.99Zm15.99,7.71h-2.07v-7.38c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.38h-2.07v-12.94h2.07v2.15h.05c.98-1.63,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.12,2.23,1.12,3.96v7.91Z" />
				<path d="m487.75,241.77h-9.4v-18.13h2.12v16.2h7.28v1.92Zm3.56-16.23c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.23h-2.07v-12.94h2.07v12.94Zm14.36-12.94l-5.16,12.94h-2.04l-4.9-12.94h2.28l3.29,9.4c.24.69.4,1.29.46,1.81h.05c.08-.65.22-1.23.4-1.76l3.44-9.45h2.19Zm3.28-3.29c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.23h-2.07v-12.94h2.07v12.94Zm14.93,0h-2.07v-7.38c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.38h-2.07v-12.94h2.07v2.15h.05c.98-1.63,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.12,2.23,1.12,3.96v7.91Zm14.95-1.04c0,4.75-2.28,7.13-6.83,7.13-1.6,0-3-.3-4.2-.91v-2.07c1.46.81,2.85,1.21,4.17,1.21,3.19,0,4.78-1.69,4.78-5.08v-1.42h-.05c-.99,1.65-2.47,2.48-4.45,2.48-1.61,0-2.91-.57-3.89-1.72-.98-1.15-1.47-2.7-1.47-4.64,0-2.2.53-3.95,1.58-5.25,1.06-1.3,2.51-1.95,4.35-1.95s3.04.7,3.88,2.1h.05v-1.79h2.07v11.91Zm-2.07-4.82v-1.91c0-1.03-.35-1.91-1.05-2.64-.69-.73-1.55-1.1-2.59-1.1-1.28,0-2.28.47-3.01,1.4-.72.93-1.09,2.23-1.09,3.91,0,1.44.35,2.6,1.04,3.46.7.86,1.62,1.29,2.77,1.29s2.11-.41,2.83-1.24c.73-.83,1.1-1.88,1.1-3.17Z" />
				<polygon points="553.21 223.65 544.51 244.78 542.58 244.78 551.25 223.65 553.21 223.65" />
				<path d="m555.32,241.77v-18.13h5.01c6.39,0,9.58,2.95,9.58,8.84,0,2.8-.89,5.05-2.67,6.75-1.77,1.69-4.14,2.54-7.12,2.54h-4.8Zm2.12-16.2v14.28h2.7c2.38,0,4.23-.64,5.55-1.91,1.32-1.27,1.98-3.08,1.98-5.41,0-4.64-2.47-6.96-7.41-6.96h-2.83Zm16.73-.03c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.23h-2.07v-12.94h2.07v12.94Zm14.86,0h-2.07v-7.38c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.38h-2.07v-12.94h2.07v2.15h.05c.98-1.63,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.12,2.23,1.12,3.96v7.91Zm4.89-16.23c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.23h-2.07v-12.94h2.07v12.94Zm14.86,0h-2.07v-7.38c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.38h-2.07v-12.94h2.07v2.15h.05c.98-1.63,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.12,2.23,1.12,3.96v7.91Zm14.88-1.04c0,4.75-2.28,7.13-6.83,7.13-1.6,0-3-.3-4.2-.91v-2.07c1.46.81,2.85,1.21,4.17,1.21,3.19,0,4.78-1.69,4.78-5.08v-1.42h-.05c-.99,1.65-2.47,2.48-4.45,2.48-1.61,0-2.91-.57-3.89-1.72-.98-1.15-1.47-2.7-1.47-4.64,0-2.2.53-3.95,1.58-5.25,1.06-1.3,2.51-1.95,4.35-1.95s3.04.7,3.88,2.1h.05v-1.79h2.07v11.91Zm-2.07-4.82v-1.91c0-1.03-.35-1.91-1.05-2.64-.69-.73-1.55-1.1-2.59-1.1-1.28,0-2.28.47-3.01,1.4-.72.93-1.09,2.23-1.09,3.91,0,1.44.35,2.6,1.04,3.46.7.86,1.62,1.29,2.77,1.29s2.11-.41,2.83-1.24c.73-.83,1.1-1.88,1.1-3.17Z" />
				<path d="m650.47,241.77h-2.53l-3.03-5.08c-.28-.47-.55-.87-.81-1.2-.26-.34-.53-.61-.81-.82-.27-.21-.56-.36-.88-.46-.31-.1-.67-.15-1.06-.15h-1.74v7.71h-2.12v-18.13h5.41c.79,0,1.52.1,2.19.3.67.19,1.26.49,1.74.9.5.4.88.91,1.16,1.52.28.6.42,1.3.42,2.11,0,.63-.1,1.21-.29,1.74-.19.52-.45.99-.81,1.4-.35.41-.77.77-1.26,1.06-.49.29-1.04.51-1.66.67v.05c.3.13.56.29.78.47.23.17.44.37.64.61.2.24.4.51.59.81.2.29.43.64.67,1.04l3.4,5.45Zm-10.87-16.2v6.57h2.88c.53,0,1.02-.08,1.47-.24.45-.16.85-.39,1.18-.68.33-.3.59-.67.77-1.1.19-.44.28-.93.28-1.47,0-.97-.32-1.72-.95-2.26-.62-.55-1.53-.82-2.72-.82h-2.91Zm18.41,16.51c-1.91,0-3.44-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.17.59-3.87,1.78-5.09,1.19-1.22,2.79-1.83,4.82-1.83s3.43.59,4.51,1.78c1.09,1.19,1.63,2.84,1.63,4.94s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.81c-1.33,0-2.38.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.74s.39,2.74,1.18,3.63c.78.88,1.83,1.33,3.15,1.33s2.37-.43,3.08-1.3c.72-.87,1.09-2.1,1.09-3.7s-.36-2.87-1.09-3.74c-.72-.88-1.74-1.31-3.08-1.31Zm14.94,11.81c-1.91,0-3.44-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.17.59-3.87,1.78-5.09,1.19-1.22,2.79-1.83,4.82-1.83s3.43.59,4.51,1.78c1.09,1.19,1.63,2.84,1.63,4.94s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.81c-1.33,0-2.38.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.74s.39,2.74,1.18,3.63,1.83,1.33,3.15,1.33,2.37-.43,3.08-1.3c.72-.87,1.09-2.1,1.09-3.7s-.36-2.87-1.09-3.74c-.72-.88-1.74-1.31-3.08-1.31Zm27.91,11.5h-2.07v-7.43c0-1.43-.22-2.47-.67-3.11-.44-.64-1.18-.96-2.22-.96-.88,0-1.64.4-2.26,1.21-.62.81-.92,1.78-.92,2.91v7.38h-2.07v-7.69c0-2.54-.98-3.82-2.95-3.82-.91,0-1.66.38-2.25,1.15-.59.76-.88,1.75-.88,2.97v7.38h-2.07v-12.94h2.07v2.05h.05c.92-1.57,2.26-2.35,4.02-2.35.88,0,1.66.25,2.31.75.66.49,1.11,1.13,1.35,1.93.96-1.79,2.39-2.68,4.3-2.68,2.85,0,4.27,1.76,4.27,5.27v7.98Z" />
				<path d="m546.86,261.26c0,1.21-.12,2.28-.36,3.23-.24.94-.59,1.74-1.05,2.39-.46.65-1.02,1.15-1.68,1.49-.66.34-1.42.51-2.26.51s-1.64-.15-2.3-.46v-1.44c.73.41,1.51.62,2.34.62.59,0,1.13-.12,1.59-.37.47-.25.87-.6,1.2-1.07.32-.47.57-1.05.74-1.74.17-.69.26-1.47.26-2.36h-.04c-.56,1.13-1.55,1.7-2.94,1.7-.56,0-1.08-.1-1.55-.29-.47-.2-.88-.48-1.22-.85-.34-.37-.61-.8-.8-1.31s-.29-1.06-.29-1.66c0-.65.1-1.24.31-1.78.21-.54.51-1,.88-1.39.38-.39.83-.7,1.34-.91.52-.21,1.09-.32,1.7-.32.66,0,1.25.13,1.76.4.52.26.95.65,1.3,1.17.35.51.62,1.14.8,1.89.18.75.28,1.6.28,2.57Zm-1.63-1.35c0-.51-.07-.97-.2-1.39-.13-.42-.31-.77-.54-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.01.22c-.31.14-.59.34-.82.61-.23.26-.41.57-.54.93-.13.36-.19.74-.19,1.17,0,.47.06.88.18,1.25.13.37.31.68.54.94.23.25.51.44.84.58.33.13.7.2,1.09.2.35,0,.68-.06.98-.19.31-.13.58-.31.81-.53.23-.23.41-.49.54-.79.13-.31.2-.63.2-.98Z" />
				<rect x="549.29" y="255.46" width="1.33" height="4.11" />
				<path d="m558.72,268.65h-1.51v-11.39c-.12.12-.29.25-.52.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Zm10.17,0h-1.51v-11.39c-.12.12-.29.25-.52.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Z" />
				<path d="m575.23,255.46v4.11h-1.33v-4.11h1.33Zm3.05,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m593.35,259.23l-3.16,4.76,3.11,4.65h-1.76l-1.85-3.05c-.12-.19-.25-.43-.41-.72h-.04c-.03.06-.17.29-.43.72l-1.89,3.05h-1.74l3.21-4.62-3.07-4.8h1.76l1.82,3.22c.13.24.27.48.4.74h.04l2.35-3.95h1.66Z" />
				<path d="m605.41,268.65h-1.51v-11.39c-.12.12-.29.25-.51.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Zm10.17,0h-1.51v-11.39c-.12.12-.29.25-.51.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Z" />
				<rect x="620.59" y="255.46" width="1.33" height="4.11" />
				<path d="m632.65,256.33c-.2.35-.45.78-.74,1.31-.28.52-.58,1.11-.9,1.76-.32.65-.64,1.35-.97,2.1s-.64,1.52-.93,2.32c-.29.8-.54,1.61-.76,2.43-.21.82-.37,1.62-.47,2.41h-1.62c.11-.78.28-1.58.51-2.4.23-.82.49-1.62.78-2.41.29-.79.6-1.55.93-2.28.32-.73.64-1.4.95-2.01.31-.61.59-1.15.84-1.62.26-.47.46-.84.62-1.1h-6.61v-1.36h8.39v.87Z" />
				<path d="m636.36,255.46v4.11h-1.33v-4.11h1.33Zm3.05,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m162.06,520.25l-2.98,10.56h-1.45l-2.17-7.71c-.09-.33-.15-.69-.17-1.07h-.03c-.03.36-.09.72-.19,1.06l-2.19,7.73h-1.44l-3.09-10.56h1.36l2.25,8.1c.09.34.15.69.18,1.06h.04c.02-.26.1-.61.23-1.06l2.33-8.1h1.19l2.24,8.16c.08.28.14.61.18.99h.03c.02-.26.09-.59.2-1.02l2.16-8.13h1.34Z" />
				<polygon points="168.22 520.25 163.16 532.55 162.03 532.55 167.08 520.25 168.22 520.25" />
				<path d="m169.45,530.8v-10.56h2.91c3.72,0,5.58,1.72,5.58,5.15,0,1.63-.52,2.94-1.55,3.93-1.03.99-2.41,1.48-4.14,1.48h-2.8Zm1.24-9.44v8.32h1.58c1.38,0,2.46-.37,3.23-1.11.77-.74,1.16-1.79,1.16-3.15,0-2.7-1.44-4.06-4.31-4.06h-1.65Z" />
			</g>
		</g>
	)
}

export default PlanH
